module.exports = __webpack_public_path__ + "static/img/13.97b2dd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/13.png
// module id = B9NE
// module chunks = 0